import * as React from 'react';
import CR29DataCore from '../CourtReporting/CR29DataCore';
import { UserRoleEnum } from '../../redux/UserSlice';



const CR29DataBA = (props: any) => {
    return (
        <React.Fragment>
            <CR29DataCore userRole={UserRoleEnum.Admin} dataSection={"PartB"} />
        </React.Fragment>
    );
}

export default CR29DataBA;